module.exports = __webpack_public_path__ + "img/baner.c46efef9.png";